import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          © 2025 Risen Star Goods. All Rights Reserved.
        </p>
        <div className="developer-info">
          <span className="developed-by">
            Website Developed by Muhammad Talha Javed
          </span>
          <div className="contact-links">
            <Link
              to="https://wa.me/+923170725045"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-link"
            >
              (+92-317-0725045)
            </Link>
            <span className="teckpik">@teckpik</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
